import script from "./DescriptionField.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionField.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionField.vue?vue&type=style&index=0&id=1559694f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1559694f"]])

export default __exports__